import { useNavigate } from "react-router-dom";
import ButtonLanguage from "../../utils/ButtonLanguage/ButtonLanguage"
import BurgerMenu from "../burger-menu/BurgerMenu";
import { useDispatch } from "react-redux";
import { bookingOpen } from "../../../actions/booking.action";

const Hearder = () => {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();

  const handleNavigate = (path:string) => {
    navigate(path)
  }

  const handleOpenResa = () => {
    dispatch(bookingOpen(true))
  }
  return (
    <div className="main-header">
      <img src="/assets/logo/logo.png" className="logo" alt="" onClick={() => handleNavigate("/")} />
      <div className="container-link-header">
        <div className="link" onClick={() => handleNavigate("/cartes")}>CARTES</div>
        <div className="link" onClick={() => handleNavigate("/events")}>GALERIE ET EVENEMENTS</div>
        <div className="link" onClick={() => handleNavigate("/contact")}>CONTACT</div>
        <button onClick={()=>handleOpenResa()} className="button-reservation"><span>RERSERVATION</span></button>
        <a href="https://www.google.com/search?sca_esv=aac09e88d3bc5d88&sxsrf=AHTn8zpYLfWJPJDMWtJMYHYziryE-bmztw:1739024932459&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzY3GiLrROoEZJR1bjEthMJSqz2GD2--oQNY6AscyexC50MavytqGsBr21YMR-0yPLLTEyebwjqXIa2giWqZYmu8A5uu3&q=Restaurant+Le+BLR+Avis&sa=X&ved=2ahUKEwi0_urapLSLAxWTK_sDHRgYJV4Q0bkNegQIQRAE&biw=1586&bih=862&dpr=2&zx=1739024952584&no_sw_cr=1&sei=TmqnZ-u4HfCikdUPyYL28A4" style={{textDecoration:"none" , marginLeft:20}}>
          <div className="link" style={{display:"flex",alignItems:"center",textDecoration:"none"}}>
            <img style={{width:"20px",height:"20px"}} src="/assets/icons/star.png" alt="avis google" />
            <div style={{marginLeft:10}}>Avis</div>
          </div>
        </a>
      </div>
      <div className="burger-menu">
        <BurgerMenu/>
      </div>
    </div>
  )
}

export default Hearder